export default __webpack_public_path__ + "static/media/night_filled.bcde4133.svg";